import { dateFormatMap, dateTypeMap } from '@op/constants';
import { dealwithLanguage, formatTime, transIntentRenderHelper } from '../../render-helper';

export default function (params: any) {
  const { date_type, intentOptions } = params;

  return [
    {
      header: 'Date',
      render: 'time',
      renderHelper: [formatTime(dateFormatMap[dateTypeMap[date_type]])],
    },
    {
      header: 'Report Text',
      render: 'text',
    },
    {
      header: 'Report Text in English',
      render: 'text_en',
    },
    {
      header: 'Report Text in Chinese',
      render: 'text_zh',
    },
    {
      header: 'Create Time',
      render: 'create_time',
    },
    {
      header: 'Report Time',
      render: 'report_time',
    },
    {
      header: 'Language',
      render: 'language',
      renderHelper: [dealwithLanguage]
    },
    {
      header: 'Intent',
      render: 'intent',
      renderHelper: [transIntentRenderHelper(intentOptions)]
    },
    {
      header: 'Battleid',
      render: 'battle_id',
    },
    {
      header: 'Reportopenid',
      render: 'report_open_id',
    },
    {
      header: 'Mode',
      render: 'mode',
    },
    {
      header: 'ID',
      render: 'id',
    },
  ];
}
